// extracted by mini-css-extract-plugin
export default {"container":"DataView_container__bSOH7","inlineTitle":"DataView_inlineTitle__9-tNr","withFormattedHTML":"DataView_withFormattedHTML__MZeF2","block":"DataView_block__9RfyT"};